import { HttpUrlEncodingCodec } from '../../../node_modules/@angular/common/http';

export class CustomEncoder extends HttpUrlEncodingCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }

  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/helpers/params-encoder.ts